import React, { Component } from "react";
import DataTable from "react-data-table-component";
import { API } from "../../../config/API";
import Loader from "../../../components/Loader/Loader";
import { ReportTableCol } from "./ReportTableCol";
import "./Report.css";
import axios from "axios";
import { Util } from "../../../config/Util";
import ReactECharts from 'echarts-for-react';
import { demo } from "./reportDemo";

export default class Report extends Component {
  constructor() {
    super();
    this.state = {
      loader: false,
      data: [],
      taskList: [],
      userList: [],
      selectedUser : '',
      userDataReport :[],
      taskDataReport : [],
      taskReportType: "",
      taskReportId: "",
      taskReportStatus : '',
      projectReportPjct :'',
      projectReportType:'',
      projectReportId:'',
      projectReportStatus:'',
      levelReportLvl :'',
      levelReportType:'',
      levelReportId:'',
      levelReportStatus:'',
      taskListPjct:[],
      projectDataReport:[],
      taskListLevel:[],
      levelDataReport:[],
      reportIndex : 0,
      assessmentGraph : [ { title: 'Completed', value: 0, color: '#4CAF50' },
                          { title: 'In Progress', value: 0, color: '#36A2EB' },
                          { title: 'Failed', value: 0, color: '#FFCE56' },
                          { title: 'OverDue', value: 0, color: '#FF0000' },
                          { title: 'PendingReview', value: 0, color: '#00008B' }],
      communicationGraph : [{ title: 'Completed', value: 0, color: '#4CAF50'},
                            { title: 'In Progress', value: 0, color: '#36A2EB'},
                            { title: 'OverDue', value: 0, color: '#FF0000' }],
      trainingGraph : [ { title: 'Completed', value: 0, color: '#4CAF50'},
                        { title: 'In Progress', value: 0, color: '#36A2EB'},
                        { title: 'OverDue', value: 0, color: '#FF0000' }]
    };
   
  }

  

  componentDidMount() {
    this.loadUserList();
    
  }

  //Load Report
  loadReportData=()=>{
    this.setState({ loader: true });
    let user = Util.getFromSession("auth");
    axios.get(API.getDepartmentDataReport+"?id="+user.id)
    .then((resp) => {
      if (resp.status === 200 && resp.data) {
           //create assessment graph

            const objAs = resp.data.assessment.myDepartment;
            const objTr = resp.data.training.myDepartment;
            const objCom = resp.data.communication.myDepartment;
            
            const newState = {};
            
            // Set assessment graph - use default state values if myDepartment is null
            if (objAs) {
              newState.assessmentGraph = [
                { title: 'Completed', value: objAs.completed, color: '#4CAF50' },
                { title: 'In Progress', value: objAs.inProgress, color: '#36A2EB' },
                { title: 'OverDue', value: objAs.overDue, color: '#FF0000' },
                { title: 'Failed', value: objAs.failed, color: '#FFCE56' },
                { title: 'PendingReview', value: objAs.pendingReview, color: '#00008B' }
              ];
            }
            
            // Set training graph - use default state values if myDepartment is null
            if (objTr) {
              newState.trainingGraph = [
                { title: 'Completed', value: objTr.completed, color: '#4CAF50'},
                { title: 'In Progress', value: objTr.inProgress, color: '#36A2EB'},
                { title: 'OverDue', value: objTr.overDue, color: '#FF0000' }
              ];
            }
            
            // Set communication graph - use default state values if myDepartment is null
            if (objCom) {
              newState.communicationGraph = [
                { title: 'Completed', value: objCom.completed, color: '#4CAF50'},
                { title: 'In Progress', value: objCom.inProgress, color: '#36A2EB'},
                { title: 'OverDue', value: objCom.overDue, color: '#FF0000' }
              ];
            }
            
            this.setState(newState);
      }
    })
    .catch((er) => {})
    .finally(() => {
      this.setState({ loader: false });
    });
  }

  getChartOption = (data, title) => {
    const chartData = data.filter(item => item.value > 0).map(item => ({
      name: item.title,
      value: item.value,
      itemStyle: { color: item.color }
    }));

    return {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        show: false
      },
      series: [
        {
          name: title,
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['50%', '50%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '20',
              fontWeight: 'bold',
              formatter: '{b}\n{c}'
            },
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          labelLine: {
            show: false
          },
          data: chartData
        }
      ]
    };
  }

  //Load user list
  loadUserList = () => {
    this.setState({ loader: true });
    axios
      .get(API.listUser)
      .then((resp) => {
        if (resp.status === 200 && resp.data) {
          this.setState({ userList: resp.data.users });
        }
      })
      .catch((er) => {})
      .finally(() => {
        this.setState({ loader: false });
        this.loadReportData();
      });
  };

  filterData = (e) => {};
  //Trigger when type is selected
  populateTaskList = (e , flag) => {
    const val = String(e.target.value);
    let endPoint = "";
    if (val === "COMMUNICATIONS") {
      endPoint = API.listCommunication;
    } else if (val === "TRAININGS") {
      endPoint = API.listTraining;
    } else {
      endPoint = API.listAssessment;
    }
    const jsonKey = val.toLowerCase();
    this.setState({ loader: true });
    axios
      .get(endPoint)
      .then((res) => {
        if (res && res.data && res.data.status === "S") {
          const data = res.data[jsonKey];
          if(flag === 'P'){
            this.setState({ taskListPjct: data });
          }else  if(flag === 'L'){
            this.setState({ taskListLevel: data });
          }
          else{
            this.setState({ taskList: data });
          }
         
        }
        this.setState({ loader: false });
      })
      .catch((er) => {
        this.setState({ loader: false });
      });
  };
  // Get report by task
  getReportByTask = () => {
    this.setState({ loader: true });
    const req = {
      type: this.state.taskReportType.slice(0, -1),
      id: this.state.taskReportId,
      status: this.state.taskReportStatus
    };
    axios
      .post(API.getReportByTask, req)
      .then((res) => {
        if (res && res.data && res.data.status === "S") {
          this.setState({taskDataReport : res.data.users});
        }
        this.setState({ loader: false });
      })
      .catch((er) => {
        this.setState({ loader: false });
      });
  };

  getReportByTaskDownload=()=>{
    this.setState({ loader: true });
    const req = {
      type: this.state.taskReportType.slice(0, -1),
      id: this.state.taskReportId,
      status: this.state.taskReportStatus
    };
    console.log(Util.baseURlForDownload);
    //get the user object and tennat id
    const tenantId = sessionStorage.getItem("tenantId")
    const url = Util.baseURlForDownload+API.getTaskFile+`?type=${req.type}&status=${req.status}&id=${req.id}&x-tenant-id=${tenantId}`;
    console.log(url)
    const a = document.createElement('a');
    a.href = url;
    document.body.appendChild(a);
     a.click();
     a.remove();
     this.setState({ loader: false });
   
  }

  //Fetch report of a user
  generateUserReport=(e)=>{
    
    this.setState({ loader: true });
    axios
      .post(API.getReportByUser, {id : this.state.selectedUser})
      .then((resp) => {
        if (resp.status === 200 && resp.data) {
          this.setState({ userDataReport: resp.data.tasks });
        }
      })
      .catch((er) => {})
      .finally(() => {
        this.setState({ loader: false });
      });
  }

  generateUserReportDownload=()=>{
    this.setState({ loader: true });
    const tenantId = sessionStorage.getItem("tenantId")
    const url = Util.baseURlForDownload+API.getUserFile+`?id=${this.state.selectedUser}&x-tenant-id=${tenantId}`;
    //window.open(url);
    const a = document.createElement('a');
    a.href = url;
    document.body.appendChild(a);
     a.click();
     a.remove();
     this.setState({ loader: false });
  }
  //Report by Project
  generateProjectReport =()=>{
    this.setState({ loader: true });
    const req = {
      project : this.state.projectReportPjct,
      type: this.state.projectReportType.slice(0, -1),
      id: this.state.projectReportId,
      status: this.state.projectReportStatus
    };
    axios
      .post(API.getReportByProject, req)
      .then((res) => {
        if (res && res.data && res.data.status === "S") {
          this.setState({projectDataReport : res.data.users});
        }
        this.setState({ loader: false });
      })
      .catch((er) => {
        this.setState({ loader: false });
      });
  }
  
  //Report by Level
  generateLevelReport =()=>{
    this.setState({ loader: true });
    const req = {
      level : this.state.levelReportLvl,
      type: this.state.levelReportType.slice(0, -1),
      id: this.state.levelReportId,
      status: this.state.levelReportStatus
    };
    axios
      .post(API.getReportByLevel, req)
      .then((res) => {
        if (res && res.data && res.data.status === "S") {
          this.setState({levelDataReport : res.data.users});
        }
        this.setState({ loader: false });
      })
      .catch((er) => {
        this.setState({ loader: false });
      });
  }

  //Report by Project - Excel
  generateProjectReportDownload=()=>{
    this.setState({ loader: true });
    const req = {
      project : this.state.projectReportPjct,
      type: this.state.projectReportType.slice(0, -1),
      id: this.state.projectReportId,
      status: this.state.projectReportStatus
    };
    const tenantId = sessionStorage.getItem("tenantId")
    const url = Util.baseURlForDownload+API.getProjectFile+`?project=${req.project}&type=${req.type}&status=${req.status}&id=${req.id}&x-tenant-id=${tenantId}`;
    const a = document.createElement('a');
    a.href = url;
    document.body.appendChild(a);
     a.click();
     a.remove();
     this.setState({ loader: false });
   
  }

  //Report by Level - Excel
  generateLevelReportDownload=()=>{
    this.setState({ loader: true });
    const req = {
      level : this.state.levelReportLvl,
      type: this.state.levelReportType.slice(0, -1),
      id: this.state.levelReportId,
      status: this.state.levelReportStatus
    };
    const tenantId = sessionStorage.getItem("tenantId")
    const url = Util.baseURlForDownload+API.getLevelkFile+`?level=${req.level}&type=${req.type}&status=${req.status}&id=${req.id}&x-tenant-id=${tenantId}`;
    const a = document.createElement('a');
    a.href = url;
    document.body.appendChild(a);
     a.click();
     a.remove();
     this.setState({ loader: false });
   
  }

  render() {
    const projects = JSON.parse(localStorage.getItem("ElmaamProjects"));
    const levels = JSON.parse(localStorage.getItem("ElmaamLevels"));
    const chartDimensions = {
      width: 200, // Specify the desired width
      height: 200, // Specify the desired height
    };
    const labelStyle = {
      fontSize: '5px', // Set the desired font size
    };
    return (
      <div className="report-view-wrapper">
        <Loader loading={this.state.loader}></Loader>
        <div className="bread-crumb overflow-auto">
          <div>
            <span className="breadcrumb-title">
              <input
                type="button"
                className="btn"
                value="Home - Report"
              ></input>
            </span>
          </div>
        </div>

        <div className="chart-container" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '8px', padding: '20px', marginBottom: '20px' }}>
          <div className="chart-head" style={{  padding: '12px 20px', marginBottom: '20px', borderRadius: '6px' }}>
            <h5 style={{ margin: '0', fontSize: '18px', fontWeight: '600' }}>DEPARTMENT OVERVIEW</h5>
          </div>
          <div className="row">
            {/* Communication Chart */}
            <div className="col-md-4">
              <div className="card mb-3">
                <div className="card-header text-center bg-primary text-white">
                  <h6 className="mb-0">COMMUNICATION</h6>
                </div>
                <div className="card-body p-2">
                  <div style={{ height: '250px', width: '100%' }}>
                    <ReactECharts 
                      option={this.getChartOption(this.state.communicationGraph, 'Communication')}
                      style={{ height: '100%', width: '100%' }}
                      notMerge={true}
                      lazyUpdate={true}
                    />
                  </div>
                  <div className="legend-box mt-2">
                    {this.state.communicationGraph.filter(item => item.value > 0).map((entry) => (
                      <div key={entry.title} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', padding: '4px', borderRadius: '4px', backgroundColor: '#f8f9fa' }}>
                        <div style={{ width: '16px', height: '16px', backgroundColor: entry.color, marginRight: '8px', borderRadius: '3px' }} />
                        <span style={{ fontSize: '14px', fontWeight: '500' }}>{entry.title}: </span>
                        <span style={{ fontSize: '14px', marginLeft: '4px', color: '#495057' }}>{entry.value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Assessment Chart */}
            <div className="col-md-4">
              <div className="card mb-3">
                <div className="card-header text-center bg-success text-white">
                  <h6 className="mb-0">ASSESSMENTS</h6>
                </div>
                <div className="card-body p-2">
                  <div style={{ height: '250px', width: '100%' }}>
                    <ReactECharts 
                      option={this.getChartOption(this.state.assessmentGraph, 'Assessment')}
                      style={{ height: '100%', width: '100%' }}
                      notMerge={true}
                      lazyUpdate={true}
                    />
                  </div>
                  <div className="legend-box mt-2">
                    {this.state.assessmentGraph.filter(item => item.value > 0).map((entry) => (
                      <div key={entry.title} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', padding: '4px', borderRadius: '4px', backgroundColor: '#f8f9fa' }}>
                        <div style={{ width: '16px', height: '16px', backgroundColor: entry.color, marginRight: '8px', borderRadius: '3px' }} />
                        <span style={{ fontSize: '14px', fontWeight: '500' }}>{entry.title}: </span>
                        <span style={{ fontSize: '14px', marginLeft: '4px', color: '#495057' }}>{entry.value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Training Chart */}
            <div className="col-md-4">
              <div className="card mb-3">
                <div className="card-header text-center bg-warning text-dark">
                  <h6 className="mb-0">TRAINING</h6>
                </div>
                <div className="card-body p-2">
                  <div style={{ height: '250px', width: '100%' }}>
                    <ReactECharts 
                      option={this.getChartOption(this.state.trainingGraph, 'Training')}
                      style={{ height: '100%', width: '100%' }}
                      notMerge={true}
                      lazyUpdate={true}
                    />
                  </div>
                  <div className="legend-box mt-2">
                    {this.state.trainingGraph.filter(item => item.value > 0).map((entry) => (
                      <div key={entry.title} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', padding: '4px', borderRadius: '4px', backgroundColor: '#f8f9fa' }}>
                        <div style={{ width: '16px', height: '16px', backgroundColor: entry.color, marginRight: '8px', borderRadius: '3px' }} />
                        <span style={{ fontSize: '14px', fontWeight: '500' }}>{entry.title}: </span>
                        <span style={{ fontSize: '14px', marginLeft: '4px', color: '#495057' }}>{entry.value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        

        <div className="report-card-wrapper row" style={{ marginBottom: '30px', padding: '0 15px' }}>
          <div className="col-md-3 mb-3">
            <div 
              className={`card h-100 shadow-sm ${this.state.reportIndex === 1 ? 'border-primary' : ''}`} 
              style={{ 
                cursor: 'pointer', 
                transition: 'all 0.3s ease',
                border: this.state.reportIndex === 1 ? '2px solid #0d6efd' : '1px solid #dee2e6',
                borderRadius: '8px',
                overflow: 'hidden'
              }}
              onClick={()=>this.setState({reportIndex:1})}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 .5rem 1rem rgba(0,0,0,.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
              }}
            >
              <div 
                className="card-body text-center" 
                style={{ 
                  padding: '24px 16px',
                  background: this.state.reportIndex === 1 ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '#fff'
                }}
              >
                <h5 
                  className="card-title mb-0" 
                  style={{ 
                    fontSize: '16px', 
                    fontWeight: '600',
                    color: this.state.reportIndex === 1 ? '#fff' : '#333'
                  }}
                >
                  REPORT BY TASK
                </h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div 
              className={`card h-100 shadow-sm ${this.state.reportIndex === 2 ? 'border-success' : ''}`} 
              style={{ 
                cursor: 'pointer', 
                transition: 'all 0.3s ease',
                border: this.state.reportIndex === 2 ? '2px solid #198754' : '1px solid #dee2e6',
                borderRadius: '8px',
                overflow: 'hidden'
              }}
              onClick={()=>this.setState({reportIndex:2})}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 .5rem 1rem rgba(0,0,0,.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
              }}
            >
              <div 
                className="card-body text-center" 
                style={{ 
                  padding: '24px 16px',
                  background: this.state.reportIndex === 2 ? 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' : '#fff'
                }}
              >
                <h5 
                  className="card-title mb-0" 
                  style={{ 
                    fontSize: '16px', 
                    fontWeight: '600',
                    color: this.state.reportIndex === 2 ? '#fff' : '#333'
                  }}
                >
                  REPORT BY USER
                </h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div 
              className={`card h-100 shadow-sm ${this.state.reportIndex === 3 ? 'border-warning' : ''}`} 
              style={{ 
                cursor: 'pointer', 
                transition: 'all 0.3s ease',
                border: this.state.reportIndex === 3 ? '2px solid #ffc107' : '1px solid #dee2e6',
                borderRadius: '8px',
                overflow: 'hidden'
              }}
              onClick={()=>this.setState({reportIndex:3})}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 .5rem 1rem rgba(0,0,0,.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
              }}
            >
              <div 
                className="card-body text-center" 
                style={{ 
                  padding: '24px 16px',
                  background: this.state.reportIndex === 3 ? 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' : '#fff'
                }}
              >
                <h5 
                  className="card-title mb-0" 
                  style={{ 
                    fontSize: '16px', 
                    fontWeight: '600',
                    color: this.state.reportIndex === 3 ? '#fff' : '#333'
                  }}
                >
                  REPORT BY PROJECT
                </h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div 
              className={`card h-100 shadow-sm ${this.state.reportIndex === 4 ? 'border-info' : ''}`} 
              style={{ 
                cursor: 'pointer', 
                transition: 'all 0.3s ease',
                border: this.state.reportIndex === 4 ? '2px solid #0dcaf0' : '1px solid #dee2e6',
                borderRadius: '8px',
                overflow: 'hidden'
              }}
              onClick={()=>this.setState({reportIndex:4})}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 .5rem 1rem rgba(0,0,0,.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
              }}
            >
              <div 
                className="card-body text-center" 
                style={{ 
                  padding: '24px 16px',
                  background: this.state.reportIndex === 4 ? 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' : '#fff'
                }}
              >
                <h5 
                  className="card-title mb-0" 
                  style={{ 
                    fontSize: '16px', 
                    fontWeight: '600',
                    color: this.state.reportIndex === 4 ? '#fff' : '#333'
                  }}
                >
                  REPORT BY LEVEL
                </h5>
              </div>
            </div>
          </div>
        </div>

        {this.state.reportIndex === 1 && (
          <div className="report-overview-table mt-2">
            {/* <div className="table-title-box">
              <span>REPORT BY TASK</span>
            </div> */}
            <div className="card shadow-sm mb-4" style={{ border: '1px solid #e3e6f0', borderRadius: '8px' }}>
              <div className="card-body" style={{ padding: '20px' }}>
                <div className="d-flex align-items-center mb-3">
                  <i className="fas fa-filter" style={{ color: '#4e73df', fontSize: '18px', marginRight: '10px' }}></i>
                  <h6 className="mb-0" style={{ color: '#5a5c69', fontWeight: '600' }}>Filter Options</h6>
                </div>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label" style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69', marginBottom: '8px' }}>Type</label>
                    <select
                      className="form-select"
                      style={{ borderRadius: '6px', border: '1px solid #d1d3e2', fontSize: '14px', padding: '10px 12px' }}
                    onChange={(e) => {
                      this.setState({ taskReportType: e.target.value });
                      this.populateTaskList(e);
                    }}
                    value={this.state.taskReportType}
                  >
                    <option value="">SELECT TYPE</option>
                    <option value="COMMUNICATIONS">COMMUNICATION</option>
                    <option value="TRAININGS">TRAINING</option>
                    <option value="ASSESSMENTS">ASSESSMENT</option>
                  </select>
                </div>

                <div className="col-md-3">
                  <label className="form-label" style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69', marginBottom: '8px' }}>Item</label>
                  <select
                    className="form-select"
                    style={{ borderRadius: '6px', border: '1px solid #d1d3e2', fontSize: '14px', padding: '10px 12px' }}
                    value={this.state.taskReportId}
                    onChange={(e) =>
                      this.setState({ taskReportId: e.target.value })
                    }
                  >
                    <option value="">SELECT TASK</option>
                    {this.state.taskList.map((task) => {
                      return (
                        <option key={task.id} value={task.id}>
                          {task.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="col-md-3">
                    <label className="form-label" style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69', marginBottom: '8px' }}>Status</label>
                    <select
                      className="form-select"
                      style={{ borderRadius: '6px', border: '1px solid #d1d3e2', fontSize: '14px', padding: '10px 12px' }}
                      value={this.state.taskReportStatus}
                      onChange={(e) =>
                        this.setState({ taskReportStatus: e.target.value })
                      }
                    >
                      <option value="">SELECT STATUS</option>
                      <option value="ALL">ALL</option>
                      <option value="COMPLETED">COMPLETED</option>
                      <option value="CREATED">PENDING</option>
                      <option value="OVERDUE">OVERDUE</option>
                    </select>
                  </div>

                  <div className="col-md-3 d-flex align-items-end gap-2">
                    <button
                      className="btn btn-primary flex-fill"
                      style={{ borderRadius: '6px', padding: '10px 20px', fontWeight: '600', fontSize: '14px' }}
                      onClick={this.getReportByTask}
                      disabled={
                        !this.state.taskReportType ||
                        !this.state.taskReportId ||
                        !this.state.taskReportStatus
                      }
                    >
                      <i className="fas fa-eye me-2"></i>VIEW
                    </button>
                    <button
                      className="btn btn-success flex-fill"
                      style={{ borderRadius: '6px', padding: '10px 20px', fontWeight: '600', fontSize: '14px' }}
                      onClick={this.getReportByTaskDownload}
                      disabled={
                        !this.state.taskReportType ||
                        !this.state.taskReportId ||
                        !this.state.taskReportStatus
                      }
                    >
                      <i className="fas fa-download me-2"></i>EXPORT
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <DataTable
              columns={ReportTableCol.taskReportTable}
              defaultSortFieldId="id"
              data={this.state.taskDataReport}
              pagination
              striped
            />
          </div>
        )}

        {this.state.reportIndex === 2 && (
          <div className="report-overview-table mt-2">
            {/* <div className="table-title-box">
              <span>REPORT BY USER</span>
            </div> */}
            <div className="card shadow-sm mb-4" style={{ border: '1px solid #e3e6f0', borderRadius: '8px' }}>
              <div className="card-body" style={{ padding: '20px' }}>
                <div className="d-flex align-items-center mb-3">
                  <i className="fas fa-user" style={{ color: '#4e73df', fontSize: '18px', marginRight: '10px' }}></i>
                  <h6 className="mb-0" style={{ color: '#5a5c69', fontWeight: '600' }}>Select User</h6>
                </div>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label" style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69', marginBottom: '8px' }}>User</label>
                    <select
                      className="form-select"
                      style={{ borderRadius: '6px', border: '1px solid #d1d3e2', fontSize: '14px', padding: '10px 12px' }}
                      value={this.state.selectedUser}
                      onChange={(e) =>
                        this.setState({ selectedUser: e.target.value })
                      }
                    >
                      <option value="">SELECT USER</option>
                      {this.state.userList.map((user) => {
                        return (
                          <option key={user.id} value={user.id}>
                            {user.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-md-6 d-flex align-items-end gap-2">
                    <button
                      className="btn btn-primary flex-fill"
                      style={{ borderRadius: '6px', padding: '10px 20px', fontWeight: '600', fontSize: '14px' }}
                      onClick={this.generateUserReport}
                      disabled={!this.state.selectedUser}
                    >
                      <i className="fas fa-eye me-2"></i>VIEW
                    </button>
                    <button
                      className="btn btn-success flex-fill"
                      style={{ borderRadius: '6px', padding: '10px 20px', fontWeight: '600', fontSize: '14px' }}
                      onClick={this.generateUserReportDownload}
                      disabled={!this.state.selectedUser}
                    >
                      <i className="fas fa-download me-2"></i>EXPORT
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <DataTable
              columns={ReportTableCol.userReportTable}
              defaultSortFieldId="id"
              data={this.state.userDataReport}
              pagination
              striped
            />
          </div>
        )}

        {this.state.reportIndex === 3 && (
          <div className="report-overview-table mt-2">
            {/* <div className="table-title-box">
              <span>REPORT BY PROJECT</span>
            </div> */}
            <div className="card shadow-sm mb-4" style={{ border: '1px solid #e3e6f0', borderRadius: '8px' }}>
              <div className="card-body" style={{ padding: '20px' }}>
                <div className="d-flex align-items-center mb-3">
                  <i className="fas fa-project-diagram" style={{ color: '#4e73df', fontSize: '18px', marginRight: '10px' }}></i>
                  <h6 className="mb-0" style={{ color: '#5a5c69', fontWeight: '600' }}>Filter Options</h6>
                </div>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label" style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69', marginBottom: '8px' }}>Project</label>
                    <select
                      className="form-select"
                      style={{ borderRadius: '6px', border: '1px solid #d1d3e2', fontSize: '14px', padding: '10px 12px' }}
                      onChange={(e) => {
                        this.setState({ projectReportPjct: e.target.value });
                      }}
                      value={this.state.projectReportPjct}
                    >
                      <option value="">SELECT PROJECT</option>
                      {projects.map((p) => {
                        return (
                          <option key={p.id} value={p.id}>
                            {p.value}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-md-2">
                    <label className="form-label" style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69', marginBottom: '8px' }}>Type</label>
                    <select
                      className="form-select"
                      style={{ borderRadius: '6px', border: '1px solid #d1d3e2', fontSize: '14px', padding: '10px 12px' }}
                      onChange={(e) => {
                        this.setState({ projectReportType: e.target.value });
                        this.populateTaskList(e, "P");
                      }}
                      value={this.state.projectReportType}
                    >
                      <option value="">SELECT TYPE</option>
                      <option value="COMMUNICATIONS">COMMUNICATION</option>
                      <option value="TRAININGS">TRAINING</option>
                      <option value="ASSESSMENTS">ASSESSMENT</option>
                    </select>
                  </div>

                  <div className="col-md-2">
                    <label className="form-label" style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69', marginBottom: '8px' }}>Item</label>
                    <select
                      className="form-select"
                      style={{ borderRadius: '6px', border: '1px solid #d1d3e2', fontSize: '14px', padding: '10px 12px' }}
                    value={this.state.projectReportId}
                    onChange={(e) =>
                      this.setState({ projectReportId: e.target.value })
                    }
                  >
                    <option value="">SELECT TASK</option>
                    {this.state.taskListPjct.map((task) => {
                      return (
                        <option key={task.id} value={task.id}>
                          {task.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="col-md-2">
                  <label className="form-label" style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69', marginBottom: '8px' }}>Status</label>
                  <select
                    className="form-select"
                    style={{ borderRadius: '6px', border: '1px solid #d1d3e2', fontSize: '14px', padding: '10px 12px' }}
                    value={this.state.projectReportStatus}
                    onChange={(e) =>
                      this.setState({ projectReportStatus: e.target.value })
                    }
                  >
                    <option value="">SELECT STATUS</option>
                    <option value="ALL">ALL</option>
                    <option value="COMPLETED">COMPLETED</option>
                    <option value="CREATED">PENDING</option>
                    <option value="OVERDUE">OVERDUE</option>
                  </select>
                </div>
                
                <div className="col-md-3 d-flex align-items-end gap-2">
                  <button
                    className="btn btn-primary flex-fill"
                    style={{ borderRadius: '6px', padding: '10px 20px', fontWeight: '600', fontSize: '14px' }}
                    onClick={this.generateProjectReport}
                    disabled={
                      !this.state.projectReportPjct ||
                      !this.state.projectReportId ||
                      !this.state.projectReportStatus
                    }
                  >
                    VIEW
                  </button>
                  <button
                    className="btn btn-success flex-fill"
                    style={{ borderRadius: '6px', padding: '10px 20px', fontWeight: '600', fontSize: '14px' }}
                    onClick={this.generateProjectReportDownload}
                    disabled={
                      !this.state.projectReportPjct ||
                      !this.state.projectReportId ||
                      !this.state.projectReportStatus
                    }
                  >
                    EXPORT
                  </button>
                </div>
              </div>
            </div>
          </div>
            <DataTable
              columns={ReportTableCol.projectReportTable}
              defaultSortFieldId="id"
              data={this.state.projectDataReport}
              pagination
              striped
            />
          </div>
        )}

        {this.state.reportIndex === 4 && (
          <div className="report-overview-table mt-2">
            <div className="card shadow-sm" style={{ borderRadius: '8px', border: '1px solid #e3e6f0' }}>
              <div className="card-body" style={{ padding: '24px' }}>
                <div className="row g-3 align-items-end">
                  <div className="col-md-2">
                    <label className="form-label" style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69', marginBottom: '8px' }}>Level</label>
                    <select
                      className="form-select"
                      style={{ borderRadius: '6px', border: '1px solid #d1d3e2', fontSize: '14px', padding: '10px 12px' }}
                      onChange={(e) => {
                        this.setState({ levelReportLvl: e.target.value });
                      }}
                      value={this.state.levelReportLvl}
                    >
                      <option value="">SELECT LEVEL</option>
                      {levels.map((p) => {
                        return (
                          <option key={p.id} value={p.id}>
                            {p.value}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-md-2">
                    <label className="form-label" style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69', marginBottom: '8px' }}>Type</label>
                    <select
                      className="form-select"
                      style={{ borderRadius: '6px', border: '1px solid #d1d3e2', fontSize: '14px', padding: '10px 12px' }}
                      onChange={(e) => {
                        this.setState({ levelReportType: e.target.value });
                        this.populateTaskList(e, "L");
                      }}
                      value={this.state.levelReportType}
                    >
                      <option value="">SELECT TYPE</option>
                      <option value="COMMUNICATIONS">COMMUNICATION</option>
                      <option value="TRAININGS">TRAINING</option>
                      <option value="ASSESSMENTS">ASSESSMENT</option>
                    </select>
                  </div>

                  <div className="col-md-3">
                    <label className="form-label" style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69', marginBottom: '8px' }}>Item</label>
                    <select
                      className="form-select"
                      style={{ borderRadius: '6px', border: '1px solid #d1d3e2', fontSize: '14px', padding: '10px 12px' }}
                      value={this.state.levelReportId}
                      onChange={(e) =>
                        this.setState({ levelReportId: e.target.value })
                      }
                    >
                      <option value="">SELECT TASK</option>
                      {this.state.taskListLevel.map((task) => {
                        return (
                          <option key={task.id} value={task.id}>
                            {task.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-md-2">
                    <label className="form-label" style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69', marginBottom: '8px' }}>Status</label>
                    <select
                      className="form-select"
                      style={{ borderRadius: '6px', border: '1px solid #d1d3e2', fontSize: '14px', padding: '10px 12px' }}
                      value={this.state.levelReportStatus}
                      onChange={(e) =>
                        this.setState({ levelReportStatus: e.target.value })
                      }
                    >
                      <option value="">SELECT STATUS</option>
                      <option value="ALL">ALL</option>
                      <option value="COMPLETED">COMPLETED</option>
                      <option value="CREATED">PENDING</option>
                      <option value="OVERDUE">OVERDUE</option>
                    </select>
                  </div>
                  
                  <div className="col-md-3 d-flex align-items-end gap-2">
                    <button
                      className="btn btn-primary flex-fill"
                      style={{ borderRadius: '6px', padding: '10px 20px', fontWeight: '600', fontSize: '14px' }}
                      onClick={this.generateLevelReport}
                      disabled={
                        !this.state.levelReportLvl ||
                        !this.state.levelReportId ||
                        !this.state.levelReportStatus
                      }
                    >
                      VIEW
                    </button>
                    <button
                      className="btn btn-success flex-fill"
                      style={{ borderRadius: '6px', padding: '10px 20px', fontWeight: '600', fontSize: '14px' }}
                      onClick={this.generateLevelReportDownload}
                      disabled={
                        !this.state.levelReportLvl ||
                        !this.state.levelReportId ||
                        !this.state.levelReportStatus
                      }
                    >
                      EXPORT
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <DataTable
              columns={ReportTableCol.projectReportTable}
              defaultSortFieldId="id"
              data={this.state.levelDataReport}
              pagination
              striped
            />
          </div>
        )}
      </div>
    );
  }
}